import { SearchFilter } from '@aibees/elephant/feature/search-filters';
import { useMemo } from 'react';
import { parseCommaSeparatedValues } from '../utils';

export function useHasCommaSeparatedInput(
  searchInputValue: string,
  metadata?: SearchFilter['metadata']
): boolean {
  return useMemo(() => {
    return (
      !!metadata?.autocomplete?.allowCustomValuesByEnter &&
      !!searchInputValue &&
      searchInputValue.includes(',') &&
      parseCommaSeparatedValues(searchInputValue).length > 0
    );
  }, [metadata?.autocomplete?.allowCustomValuesByEnter, searchInputValue]);
}
